// extracted by mini-css-extract-plugin
export default {"button":"QuoteButton_button__XsrKh"};